import { render, staticRenderFns } from "./TripAddOns.vue?vue&type=template&id=b4cf9b2e&"
import script from "./TripAddOns.vue?vue&type=script&lang=js&"
export * from "./TripAddOns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports